import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Legacy placeholder:
 * We no longer upload ID / PoA directly on the UBO.
 * Instead, each UBO must have a linked KYC record.
 *
 * This page only exists because router.tsx still imports ./pages/UboUpload.
 * You can later replace this with a richer view or remove the route entirely.
 */
export default function UboUpload() {
  const navigate = useNavigate();

  return (
    <div className="px-4 md:px-6 pb-24 md:pb-8 pt-4 md:pt-6">
      <div className="section-box rounded-2xl border border-gray-200 bg-white p-4 md:p-6 max-w-xl mx-auto">
        <h1 className="text-2xl font-semibold mb-2">UBO Documents</h1>
        <p className="text-gray-600 mb-4">
          Direct document upload for UBOs has been replaced by the KYC flow.
        </p>

        <div className="alert-info mb-4">
          Each UBO now completes identity verification (ID, selfie, and proof of
          address) via a dedicated KYC flow, and the result is linked to the UBO.
        </div>

        <p className="text-gray-600 mb-6">
          If you were trying to update UBO information, please go back to your UBO list
          and use the KYC invite / status options from there.
        </p>

        <div className="flex flex-wrap gap-3">
          <button
            className="btn"
            onClick={() => navigate("/profile/ubos")}
          >
            Go to UBO list
          </button>
          <button
            className="btn btn-white"
            onClick={() => navigate("/kyc/status")}
          >
            View my KYC status
          </button>
        </div>
      </div>
    </div>
  );
}
